import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import './About.css';

export default function About() {
  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="ph-grid"></div>
        <div className="ph-photo" style={{backgroundImage:"url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1400&q=80')"}}></div>
        <div className="container ph-inner">
          <div className="page-tag">About Us</div>
          <h1 className="page-h">Built on <span style={{color:'var(--gold-lt)',fontStyle:'italic'}}>Expertise</span>,<br />Driven by Results</h1>
          <p className="page-sub">Over a decade of excellence in BPO, KPO &amp; financial process outsourcing from Bangalore to the world.</p>
        </div>
      </section>

      <section className="about-overview">
        <div className="container">
          <div className="ao-wrapper">
            <div>
              <div className="ao-logo-block">
                <img src={logo} alt="CSR Financial Solutions" />
                <div>
                  <div className="ao-name">CSR's Financial Solutions</div>
                  <div className="ao-pvt">Private Limited</div>
                  <div className="ao-since">Est. 2012 · Bangalore, India</div>
                </div>
              </div>
              <div className="ao-timeline">
                {[
                  ['2012',"Established as Bangalore's first professional collection firm"],
                  ['2017','Expanded with major banking & NBFC partnerships'],
                  ['2020','Diversified into BPO, KPO & international outsourcing'],
                  ['2024','Scaling AI-driven call center & global BPO operations'],
                ].map(([year,label]) => (
                  <div key={year} className="ao-tl-item">
                    <div className="ao-tl-year">{year}</div>
                    <div className="ao-tl-dot"></div>
                    <div className="ao-tl-label">{label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="ao-right">
              <div className="page-tag">Company Overview</div>
              <h2>From Collections to <span className="gold">Global Outsourcing</span></h2>
              <p>CSR's Financial Solutions Private Limited (formerly CSR Associates) is a results-driven BPO, KPO, and debt management solutions provider with over a decade of expertise in collections, customer engagement, and financial process outsourcing.</p>
              <p>Founded in 2012 and headquartered in Bangalore, India, we have evolved from a traditional call center and debt recovery firm into a scalable outsourcing partner for global clients, including banks, NBFCs, and international businesses.</p>
              <div className="ao-stats">
                {[['12+','Years Experience'],['500+','Clients Served'],['60%','Avg Cost Savings']].map(([val,lbl]) => (
                  <div key={lbl} className="ao-stat">
                    <div className="ao-stat-val">{val}</div>
                    <div className="ao-stat-lbl">{lbl}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TEAM PHOTO */}
      <div style={{height:'360px',overflow:'hidden',position:'relative'}}>
        <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1400&q=80" alt="CSR Team" style={{width:'100%',height:'100%',objectFit:'cover',objectPosition:'center 40%'}} />
        <div style={{position:'absolute',inset:0,background:'linear-gradient(to right,rgba(27,42,74,0.7) 0%,transparent 60%)'}}></div>
        <div style={{position:'absolute',left:'64px',bottom:'48px'}}>
          <div style={{fontFamily:'var(--mono)',fontSize:'0.62rem',letterSpacing:'0.2em',textTransform:'uppercase',color:'var(--gold-lt)',marginBottom:'8px'}}>Our Team</div>
          <div style={{fontFamily:'var(--serif)',fontSize:'2rem',color:'#fff',fontWeight:300}}>People who power <em>excellence</em></div>
        </div>
      </div>

      <section className="mv-section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-icon"><i className="fas fa-bullseye"></i></div>
              <h3>Our Mission</h3>
              <p>To empower businesses with cost-effective, scalable, and performance-driven outsourcing solutions that enhance recovery rates, improve customer engagement, and drive measurable growth across every engagement.</p>
            </div>
            <div className="mv-card">
              <div className="mv-icon"><i className="fas fa-globe"></i></div>
              <h3>Our Vision</h3>
              <p>To become a globally recognised outsourcing partner delivering world-class BPO, KPO, and financial solutions across India, the US, and international markets — setting the benchmark for ethical, performance-led operations.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="leadership">
        <div className="container">
          <div className="section-center">
            <div className="eyebrow">Leadership</div>
            <h2 className="section-h">Meet Our <span className="gold">Founder</span></h2>
          </div>
          <div className="leader-card">
            <div className="leader-avatar">CS</div>
            <div className="leader-info">
              <h3>Chandrahas S</h3>
              <div className="leader-role">Founder &amp; Managing Director</div>
              <p>A seasoned professional with over a decade of experience in credit, collections, and telecom industries. Chandrahas built CSR's Financial Solutions on a foundation of strong operational expertise and proven recovery strategies, evolving the company from Bangalore's first professional collection firm into a diversified global outsourcing powerhouse.</p>
              <div className="leader-tags">
                {[['fa-check','Credit & Collections Expert'],['fa-check','Telecom Industry Veteran'],['fa-check','BPO Operations Leader']].map(([icon,label]) => (
                  <span key={label}><i className={`fas ${icon}`}></i>{label}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <div className="section-center">
            <div className="eyebrow">Core Values</div>
            <h2 className="section-h">What We <span className="gold">Stand For</span></h2>
          </div>
          <div className="values-grid">
            {[
              ['fa-balance-scale','Ethical Operations','Maintaining customer dignity and operating with full regulatory compliance in all recovery activities.'],
              ['fa-tachometer-alt','Performance-Driven','Every engagement is measured by outcomes. We set targets and consistently exceed them.'],
              ['fa-handshake','Client-Centric','We treat every client partnership as a long-term relationship built on trust and transparency.'],
              ['fa-shield-alt','Data Security','Strict protocols for data protection, privacy, and information security across all operations.'],
              ['fa-expand-arrows-alt','Scalability','Infrastructure and processes designed to scale rapidly to meet your evolving business needs.'],
              ['fa-lightbulb','Innovation','Technology-driven operations incorporating AI, analytics, and modern communication tools.'],
            ].map(([icon,title,desc]) => (
              <div key={title} className="value-card">
                <div className="value-icon"><i className={`fas ${icon}`}></i></div>
                <h4>{title}</h4>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="expertise">
        <div className="container">
          <div className="section-center">
            <div className="eyebrow">Industry Expertise</div>
            <h2 className="section-h">Industries We <span className="gold">Serve</span></h2>
          </div>
          <div className="exp-grid">
            {[
              ['fa-university','Banks & Financial Institutions'],
              ['fa-building','NBFCs'],
              ['fa-mobile-alt','Telecom Companies'],
              ['fa-rocket','Fintech Startups'],
              ['fa-globe-americas','US & UK Businesses'],
              ['fa-store','SMEs & Enterprises'],
            ].map(([icon,label]) => (
              <div key={label} className="exp-card">
                <i className={`fas ${icon}`}></i>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="about-cta-inner">
            <div className="page-tag" style={{justifyContent:'center'}}>Partner With Us</div>
            <h2 className="section-h">Ready to <span className="gold">Transform</span> Your Operations?</h2>
            <p style={{fontSize:'0.9rem',color:'rgba(255,255,255,0.55)',marginTop:'16px',maxWidth:'500px',margin:'16px auto 0',lineHeight:'1.8'}}>Join hundreds of businesses that trust CSR's Financial Solutions.</p>
            <div className="cta-btns">
              <Link to="/contact" className="btn-gold"><i className="fas fa-paper-plane"></i> Get in Touch</Link>
              <Link to="/services" className="btn-outline" style={{borderColor:'rgba(255,255,255,0.3)',color:'rgba(255,255,255,0.8)'}}>View Our Services</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
